import { render } from "./FileInput.vue?vue&type=template&id=de0f4e3c&scoped=true"
import script from "./FileInput.vue?vue&type=script&lang=js"
export * from "./FileInput.vue?vue&type=script&lang=js"

import "./FileInput.vue?vue&type=style&index=0&id=de0f4e3c&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de0f4e3c"]])

export default __exports__